import { render, staticRenderFns } from "./WalletTransactionDetail.vue?vue&type=template&id=8dcffad0&"
import script from "./WalletTransactionDetail.vue?vue&type=script&lang=ts&"
export * from "./WalletTransactionDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports